import { styles } from './template.scss';
import { styles as commonStyles } from '../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../assets/text-helpers.scss';
import { FontSizes, FontWeights, LabelWidthValues } from '../../types/common/types';

export const templateTargets = document.createElement('template');

templateTargets.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>

    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <gz-title id='targets-title' class='mb-2 mt-4' fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.SEMIBOLD}'></gz-title>
    <div class='form-wrapper'>
       <div id='targets-tree-wrapper'>
         <gz-form-field id='service-targets-form' class='label-mw-250' label=''>
            <gz-dropdown gz-form-input type='dropdown' id='service-targets-drop-down' class='input-content hidden' labelWidth='${LabelWidthValues.LARGE}'></gz-dropdown>
            <gz-input-error></gz-input-error>
         </gz-form-field>
       </div>
       <div class='selected-targets-wrapper'>
         <gz-title id='selected-targets-title' class='' fontSize='${FontSizes.PARAGRAPH_11}'></gz-title>
         <gz-single-select-list id='group-search'></gz-single-select-list>
       </div>
    </div>

    <gz-info-box severity='error' id='no-targets-selected-error' class='hidden'></gz-info-box>

     <gz-form-field id='at-least-one-target-selected' class='hidden' required>
      <gz-input gz-form-input class='input-content' inputwidth='240'></gz-input>
      <gz-input-error></gz-input-error>
    </gz-form-field>

  </div>
`;
